export const stringifyUrl = ({ url, query }) => {
    const urlObj = new URL(url)
    for (let key in query) {
        urlObj.searchParams.append(encodeURIComponent(key), encodeURIComponent(query[key]))
    }
    return urlObj.toString()
}